
define('text!modules/campaign/pixelSegment/templates/grid_segment_footer.html',[],function () { return '<div class="stack" data-bind="browse_path">{{{browse_path}}}<span class="strong">{{{browse_path_end}}}&nbsp;</span></div>\n';});

